module.exports = __webpack_public_path__ + "media/images/icon__externalLink@3x-5af35cc6e738a34b017d34dd51ad3a8c.png";